import { supabase } from "./supabaseClient";

export async function uploadCustomCakeImage(file) {
  if (!file) throw new Error("Nu a fost selectată nicio imagine.");

  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
  if (!allowedTypes.includes(file.type)) {
    throw new Error("Sunt permise doar imagini JPG, PNG sau WEBP.");
  }

  if (file.size > 5 * 1024 * 1024) {
    throw new Error("Imaginea este prea mare. Maxim 5MB.");
  }

  const fileExt = file.name.split(".").pop()?.toLowerCase() || "jpg";
  const safeName = file.name
    .replace(/\.[^/.]+$/, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const fileName = `${Date.now()}-${Math.random()
    .toString(36)
    .slice(2)}-${safeName}.${fileExt}`;

  const filePath = `custom-cakes/${fileName}`;

  const { error: uploadError } = await supabase.storage
    .from("produse_admin")
    .upload(filePath, file, {
      cacheControl: "3600",
      upsert: false,
    });

  if (uploadError) {
    throw new Error(uploadError.message || "Eroare la încărcarea imaginii.");
  }

  const { data } = supabase.storage
    .from("produse_admin")
    .getPublicUrl(filePath);

  if (!data?.publicUrl) {
    throw new Error("Nu s-a putut obține URL-ul public.");
  }

  return data.publicUrl;
}
